import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const LegalLayout = ({ content, breadcrumbLabel, otherLinkTo, otherLinkLabel, testIdPrefix }) => {
  if (!content) return null;
  return (
    <div className="bg-[#F7F8FA] min-h-screen pt-16 lg:pt-20" data-testid={`${testIdPrefix}-page`}>
      {/* Hero */}
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
          <nav className="flex items-center gap-2 text-xs uppercase tracking-wider text-slate-500 mb-7" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-blue-900 transition-colors" data-testid={`${testIdPrefix}-breadcrumb-home`}>
              {breadcrumbLabel}
            </Link>
            <ChevronRight size={12} className="text-slate-300" />
            <span className="text-blue-900">{content.eyebrow}</span>
          </nav>
          <span className="section-eyebrow">{content.eyebrow}</span>
          <h1 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.05]" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {content.title}
          </h1>
          {content.intro && (
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mt-7 max-w-3xl">{content.intro}</p>
          )}
        </div>
      </section>

      {/* Sections */}
      <section className="py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10 md:space-y-12">
          {content.sections.map((section, idx) => (
            <article key={idx} className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8" data-testid={`${testIdPrefix}-section-${idx}`}>
              <div className="flex items-baseline gap-3 mb-4">
                <span className="text-blue-900 font-extrabold text-base md:text-lg tabular-nums" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <h2 className="text-xl md:text-2xl font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {section.heading}
                </h2>
              </div>
              <div className="space-y-3 pl-0 md:pl-8">
                {section.body.map((line, i) => (
                  <p key={i} className="text-slate-600 text-[15px] leading-relaxed whitespace-pre-line">{line}</p>
                ))}
              </div>
            </article>
          ))}

          <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <p className="text-slate-500 text-xs uppercase tracking-wider">{content.updated}</p>
            {otherLinkTo && (
              <Link
                to={otherLinkTo}
                className="btn-secondary text-sm"
                data-testid={`${testIdPrefix}-other-link`}
              >
                {otherLinkLabel}
                <ChevronRight size={14} />
              </Link>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalLayout;
